import { getSecretQuestionCode } from "../password/reset";
import { getIsPersonalUserCoppa } from "../personal-user";
import { getIsCoppa as getCreateIsCoppa } from "../create";
import { ROUTES } from "../../../constants";

const getIsCoppa = state => {
  const {
    router: {
      location: { pathname = "" }
    }
  } = state;

  switch (pathname.toLowerCase()) {
    case ROUTES.ACCOUNT_CREATE:
      return getCreateIsCoppa(state);
    case ROUTES.PASSWORD_RESET:
      return Boolean(getSecretQuestionCode(state));
    default:
      return getIsPersonalUserCoppa(state);
  }
};

export default getIsCoppa;
